import React, { useEffect } from "react";
import { Box, Typography } from "@mui/joy";
import { theme } from "styles/theme";

interface RecoveryToastProps {
  open: boolean;
  onDismiss: () => void;
  autoDismissMs?: number;
}

// refresh 후 cowork 측에서 agent 의 마지막 작업물을 가져왔음을 알리는 한 줄 토스트.
// 위치: workspace 상단 (ConflictBanner 와 동일 슬롯). dismissible + auto 5s.
export function RecoveryToast({
  open,
  onDismiss,
  autoDismissMs = 5_000,
}: RecoveryToastProps) {
  useEffect(() => {
    if (!open) return;
    const t = window.setTimeout(onDismiss, autoDismissMs);
    return () => window.clearTimeout(t);
  }, [open, onDismiss, autoDismissMs]);

  if (!open) return null;
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "12px",
        px: "12px",
        py: "8px",
        borderBottom: `1px solid rgba(34, 197, 94, 0.3)`,
        backgroundColor: "rgba(34, 197, 94, 0.08)",
      }}
    >
      <Typography
        level="body-xs"
        sx={{
          flex: 1,
          color: "#15803d",
          fontWeight: 600,
          fontSize: "12px",
        }}
      >
        에이전트의 마지막 작업물을 불러왔어요. 저장하지 않으면 다음 새로고침 때
        같은 안내가 다시 뜹니다.
      </Typography>
      <Box
        component="button"
        type="button"
        onClick={onDismiss}
        sx={{
          background: "none",
          border: "none",
          padding: 0,
          cursor: "pointer",
          color: theme.vars.palette.Content.Medium,
          fontSize: "11px",
          "&:hover": { color: theme.vars.palette.Content.Strong },
        }}
      >
        닫기
      </Box>
    </Box>
  );
}
